export const GET_LIST_CAT_BENEFICIADOS_LOADING =
  'catalogoBeneficiados/GET_LIST_CAT_BENEFICIADOS_LOADING';
export const GET_LIST_CAT_BENEFICIADOS_SUCCESS =
  'catalogoBeneficiados/GET_LIST_CAT_BENEFICIADOS_SUCCESS';
export const GET_LIST_CAT_BENEFICIADOS_FAILURE =
  'catalogoBeneficiados/GET_LIST_CAT_BENEFICIADOS_FAILURE';
